import { z } from "zod";
const SEARCH_RESULT_LIMIT_DEFAULT = 10;
const SEARCH_RESULT_LIMIT_MAX = 100;
export const DTOSearchableEntityType = z.enum([
    "DocumentationPage",
    "KnowledgeSkill",
    "KnowledgeFile",
]);
export const DTOSearchableEntity = z.object({
    id: z.string(),
    type: DTOSearchableEntityType,
    designSystemId: z.string().optional(),
    title: z.string(),
    path: z.string(),
    description: z.string(),
});
export const DTOSearchFullTextMatch = z.object({
    start: z.number(),
    length: z.number(),
});
export const DTOSearchPreview = z.object({
    text: z.string(),
    fullTextMatches: DTOSearchFullTextMatch.array(),
});
export const DTOSearchResultMatch = z.object({
    preview: DTOSearchPreview.optional(),
    vectorScore: z.number().optional(),
    fullTextScore: z.number().optional(),
    reciprocalRankFusionScore: z.number(),
});
export const DTOSearchResult = z.object({
    entity: DTOSearchableEntity,
    matches: DTOSearchResultMatch.array(),
    reciprocalRankFusionScore: z.number(),
});
export const DTOSearchResponse = z.object({
    results: DTOSearchResult.array(),
});
export const DTOSearchMode = z.enum(["FullText", "Vector", "Combined"]);
export const DTOSearchInput = z.object({
    workspaceId: z.string(),
    designSystemId: z
        .string()
        .nullable()
        .optional()
        .describe("Optional design system ID to search within. Pass null to search only workspace-level entities and exclude design system entities."),
    entityTypes: DTOSearchableEntityType.array()
        .optional()
        .describe("Optional entity types to search. Omit to search across all entity types."),
    mode: DTOSearchMode.describe("Search mode to use: full-text, vector, or combined ranking."),
    query: z.string().describe("Text query to search for."),
    limit: z
        .number()
        .int()
        .positive()
        .default(SEARCH_RESULT_LIMIT_DEFAULT)
        .transform((limit) => Math.min(limit, SEARCH_RESULT_LIMIT_MAX))
        .describe(`Maximum number of grouped entity results to return. Defaults to ${SEARCH_RESULT_LIMIT_DEFAULT}. Values above ${SEARCH_RESULT_LIMIT_MAX} are capped.`),
});
